import { getDevice } from "framework7";
import { useMemo } from "react";

export const useIsEnabledCapacitor = () => useMemo<boolean>(() => getDevice().capacitor, []);
